import MaterialStock from "./MaterialStock";

export default function PerformaInvoices() {
  return <MaterialStock forcedEntryType="sale" salesDocumentVariant="performa" showPerformaPdfButton />;
}
